import { firestoreTimestamp } from "@/firebaseConfig";
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import { updateOrder } from "@/collections/orders";
import {
  getOrderTotalByTableById,
  saveOrderTotalByTable
} from "@/collections/ordersTotalByTable";
import { saveOrderComment } from "@/collections/orderComments";
import { getLastZclousure, saveZclousure } from "@/collections/zClousures";
const NO_QR = "NO QR";
export default {
  mixins: [firebaseMixin],
  computed: {
    cart() {
      return this.$store.state.cart;
    },
    tableQR() {
      return this.$store.state.tableQR;
    },
    adminTableQR() {
      return this.$store.state.adminTableQR;
    },
    userProfile() {
      return this.$store.state.userProfile;
    }
  },
  methods: {
    sleep(milliseconds) {
      const date = Date.now();
      let currentDate = null;
      do {
        currentDate = Date.now();
      } while (currentDate - date < milliseconds);
    },
    async setIsPaid() {
      let amount = localStorage.getItem("amountToBePaid") || 0;
      amount = parseFloat(amount).toFixed(2);

      this.orders = JSON.parse(localStorage.getItem("payableProducts") || "[]");
      this.orders.forEach(async product => {
        try {
          let _metadata = product.metadata;
          for (const [quantity, metadata] of Object.entries(product.metadata)) {
            if (!metadata.isPaid && metadata.isSelected) {
              _metadata = {
                ..._metadata,
                [quantity]: { isPaid: true }
              };
            }
          }
          await updateOrder(product.id, {
            metadata: _metadata
          });
        } catch (error) {
          this.setlogError(
            "update_order",
            "Obtained error message in setIsPaid()",
            error.stack,
            this.$options.name
          );
        }
      });

      localStorage.setItem("payableProducts", JSON.stringify([]));

      this.showSuccessMessage(this.$t("payment.paymentMade"));
      this.$refs.sendEmailModal.openDialog([], amount, this.canBeDirect);
    },
    async saveGeneralComment(time) {
      try {
        let generalCommentText = localStorage.getItem("general-comment");

        if (generalCommentText) {
          let generalComment = {
            time: time,
            email: this.$store.getters.getEmail(false),
            tableQR: this.tableQR,
            comment: generalCommentText
          };
          await saveOrderComment(generalComment);
          localStorage.setItem("general-comment", "");
        }
      } catch (error) {
        this.setlogError(
          "save_order_comment",
          "Obtained error message in saveGeneralComment()",
          error.stack,
          this.$options.name
        );
      }
    },
    saveMyOrders() {
      let count = parseInt(localStorage.getItem("myordersQuantity") || 0);
      localStorage.setItem("myordersQuantity", (count + 1).toString());
      this.$store.commit("setMyOrderQuantity", count + 1);
    },
    buildOrder(item, time, id) {
      let email = this.$store.getters.getEmail(item.cart_type === "admin");
      let fcmToken = localStorage.getItem("fcm-token");

      let metadata = {};
      for (let index = 0; index < item.quantity; index++) {
        metadata = {
          ...metadata,
          [index]: {
            isPaid: false
          }
        };
      }
      //Check if lastZClosure is closed or not
      setTimeout(async () => {
        try {
          let lastZclousure = await getLastZclousure();
          if (lastZclousure && lastZclousure.length > 0) {
            let _data = lastZclousure[0];
            let zClosureId = parseInt(_data.z_closure_id) + 1;
            if (_data.closed_on !== null) {
              await saveZclousure(zClosureId.toString(), {
                opened_on: time,
                closed_on: null,
                total_invoiced_in_cash: 0,
                total_invoiced_on_credit_card: 0,
                total_invoiced_in_datafono: 0,
                total_invoiced_in_google_pay: 0,
                total_invoiced_in_apple_pay: 0,
                total_invoiced_in_bizum: 0
              });
            }
          }
        } catch (error) {
          this.setlogError(
            "save_zclousure",
            "Obtained error message in buildOrder()",
            error.stack,
            this.$options.name
          );
        }
      });

      let order = {
        id: id,
        isPending: true,
        email: email,
        name: item.name,
        order: item.order,
        price: item.price,
        product_id: item.product_id,
        product_type_id: item.product_type_id
          ? item.product_type_id
          : "menu_group",
        category_id: item.category_id ? item.category_id : "",
        quantity: item.quantity,
        stripeSku: item.stripeSku,
        tableQR:
          item.cart_type !== undefined && item.cart_type === "admin"
            ? this.adminTableQR
            : this.tableQR,
        fcmToken: fcmToken,
        notes: item.notes !== undefined ? item.notes : "",
        size: item.size !== "base" ? item.size : "",
        time: time,
        isOpen: true,
        metadata: metadata,
        canBeShared:
          item.starters && item.starters.length > 0
            ? true
            : item.canBeShared || false,
        type: item.priceType || "unit",
        weight: item.priceType === "weight" ? item.weight : null,
        canBeMainCourse:
          item.maincourse && item.maincourse.length > 0
            ? true
            : item.canBeMainCourse || false,
        selectOption: null,
        removeQuantity: 0,
        referer: document.referrer,
        userAgent: navigator.userAgent,
        isAddedToSummary: false,
        order_translations: item.order_translations
      };

      if (item.isMenuGroupProduct) {
        order.isMenuGroupProduct = item.isMenuGroupProduct;
        order.starters = item.starters;
        order.maincourse = item.maincourse;
        order.drinks = item.drinks;
        order.desserts = item.desserts;
      }
      return order;
    },
    async updateOrderTotalByTable() {
      let amount = localStorage.getItem("amountToBePaid") || 0;
      let time = firestoreTimestamp.fromDate(new Date());
      amount = parseFloat(amount).toFixed(2);
      if (!this.tableQR || this.tableQR === NO_QR) {
        return;
      }
      try {
        let orderTotal = await getOrderTotalByTableById(this.tableQR);
        if (orderTotal) {
          orderTotal.remaining = orderTotal.remaining - amount;
          if (orderTotal.remaining < 0) {
            orderTotal.remaining = 0;
          }
          orderTotal.time = time;
          await saveOrderTotalByTable(this.tableQR, orderTotal);
        }
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "get/save_order_total_by_table",
          "Obtained error message in updateOrderTotalByTable()",
          error.stack,
          this.$options.name
        );
      } finally {
        if (this.paymentType === "amount" || this.paymentType === "todo") {
          this.$refs.sendEmailModal.openDialog([], amount, this.canBeDirect);
        }
      }
    },
    async addAmountOrderTotalByTable(time) {
      if (!this.tableQR || this.tableQR === NO_QR) {
        return;
      }
      try {
        let orderTotal = await getOrderTotalByTableById(this.tableQR);
        if (orderTotal) {
          orderTotal.remaining += this.total;
          orderTotal.time = time;
          await saveOrderTotalByTable(this.tableQR, orderTotal);
        } else {
          await saveOrderTotalByTable(this.tableQR, {
            tableQR: this.tableQR,
            remaining: this.total,
            time: time
          });
        }
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "get/save_order_total_by_table",
          "Obtained error message in addAmountOrderTotalByTable()",
          error.stack,
          this.$options.name
        );
      }
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    async getLastZclousure() {
      try {
        return await getLastZclousure;
      } catch (error) {
        this.setlogError(
          "get_zClousure",
          "Obtained error message in getLastZclousure()",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
